module.exports = __webpack_public_path__ + "static/Visa-fb13e9ebec0690d993860e9a629f2fa6.jpg";